import axios from "@/plugins/http.service.js";
export default {
    getNewEventDetails(id) {
        var data = {
            id: id
        }
        return axios.post("api/web/new-event/get-new-event-details", data)
    },
}

